export const gzipText = (text: string): Promise<Blob> =>
	new Response(
		new Blob([text]).stream().pipeThrough(new CompressionStream('gzip')),
	).blob()
